export default "__VITE_ASSET__BLrX9dj___"